import React, { FC } from 'react';
import { Grid } from '@inplayer-org/inplayer-ui';

// components
import RichLabel from 'components/RichLabel';
import RadioFieldWithInfo from 'components/Fields/RadioFieldWithInfo';

// types
import { IvsChannelType } from 'ducks/merchantDucks/items/actions';

const { Cell } = Grid;

const TooltipMessages = {
  STANDARD: `Full HD live video (resolution up to 1080p,
  input bitrate up to 8.5Mbps)`,
  BASIC: `Video quality limited by original input
  (resolution up to 480p, input bitrate up to 1.5Mbps)`,
};

const ChannelTypeField: FC = () => (
  <Cell>
    <RichLabel>Channel type</RichLabel>
    <RadioFieldWithInfo
      tag="radiobutton_channel_type-standard"
      name="type"
      value={IvsChannelType.STANDARD}
      label="Standard"
      tooltip={TooltipMessages.STANDARD}
    />
    <RadioFieldWithInfo
      tag="radiobutton_channel_type-basic"
      name="type"
      value={IvsChannelType.BASIC}
      label="Basic"
      tooltip={TooltipMessages.BASIC}
    />
  </Cell>
);

export default ChannelTypeField;
